import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as actions from '../../../../../redux/testMode/actions.testMode';
import asyncDispatch from '../../../../../services/mini/asyncDispatch';
import SourceInfo from './SourceInfo';
import getConversationId from '../../../../../services/mini/getConversationId';
import RequestEditor from '../RequestEditor/RequestEditor';
class RequestTestModeBubble extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            editMode: false,
        };

        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    enterEditMode = () => {
        this.setState({ editMode: true });
    }

    exitEditMode = () => {
        this.setState({ editMode: false });
    }

    update = ({ text }) => {
        const { updateText, dialogTree, node, conversationId } = this.props;
        const { saving } = this.state;

        if (saving) return;

        this.setState({ saving: true }, () => {
            updateText({
                dialogTree,
                text,
                curNode: node,
                conversationId
            }).then(() => {
                if (!this._isMounted) return;
                this.setState({ saving: false });
                this.exitEditMode();
            }, () => {
                if (!this._isMounted) return;
                this.setState({ saving: false });
            });
        });
    }

    render() {
        const {
            data,
            node,
            codeLinksAreShownGlobally
        } = this.props;
        const { editMode, text, saving } = this.state;

        return (
            <React.Fragment>
                <div className={`request ${editMode && 'edit-mode'}`}>
                    {codeLinksAreShownGlobally &&
                        <SourceInfo info={node.meta.pLoc} type="intent" />}
                    {editMode ?
                        <RequestEditor
                            text={data?.text}
                            node={node}
                            saving={saving}
                            onUpdate={this.update}
                            onExitEditMode={this.exitEditMode} /> :
                        <div
                            className="request__view-mode"
                            onClick={this.enterEditMode}>
                            {data?.text || (_.isString(data) ? data : '')}
                        </div>}
                </div>
            </React.Fragment>
        );
    }
}


function mapStateToProps({ testMode, projectsInfo }, ownProps) {
    return {
        dialogTree: testMode.dialogTree,
        codeLinksAreShownGlobally: testMode.codeLinksAreShownGlobally,
        conversationId: getConversationId(projectsInfo.currentProject.conversations)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        updateText: (param) => asyncDispatch(actions.updateText, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(RequestTestModeBubble);